<template>
    <div class="main">
        <c-panel title="LEGISLAÇÕES E CONVENÇÕES" titleIcon="fas fa-gavel">
            <el-alert type="info" :closable="false" class="u-mb-15"
                title="Acervo das normas aplicáveis à educação, com ementa, texto, link e anexo em PDF."
                description="Norma REVOGADA continua no acervo e continua consultável — marque-a como não vigente em vez de excluir."></el-alert>

            <el-row class="u-mb-15" :gutter="10">
                <el-col :xs="24" :sm="8">
                    <el-input v-model="filtro.busca" placeholder="Buscar em número, ementa ou texto..." @keyup.native.enter="carregar"></el-input>
                </el-col>
                <el-col :xs="12" :sm="4">
                    <el-select v-model="filtro.tipo" clearable placeholder="Tipo" style="width: 100%;" @change="carregar">
                        <el-option v-for="t in tipos" :key="t" :value="t" :label="rotulo(t)"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="12" :sm="4">
                    <el-select v-model="filtro.esfera" clearable placeholder="Esfera" style="width: 100%;" @change="carregar">
                        <el-option v-for="e in esferas" :key="e" :value="e" :label="rotulo(e)"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="12" :sm="4">
                    <el-select v-model="filtro.vigente" clearable placeholder="Vigência" style="width: 100%;" @change="carregar">
                        <el-option :value="1" label="Vigentes"></el-option>
                        <el-option :value="0" label="Revogadas"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="4" class="u-text-right">
                    <router-link v-if="podeEscrever" to="/admin/legislacao/cadastro" class="btn-new-register">
                        <el-button type="primary">NOVA NORMA</el-button>
                    </router-link>
                </el-col>
            </el-row>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 210px;">Norma</th>
                            <th>Ementa</th>
                            <th style="width: 110px;">Publicação</th>
                            <th style="width: 110px;" class="u-text-center">Vigência</th>
                            <th style="width: 150px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="l in items" :key="l.id">
                            <td>
                                {{ rotulo(l.tipo) }} {{ rotulo(l.esfera).toLowerCase() }} nº {{ l.numero }}
                                <div v-if="l.assuntos && l.assuntos.length">
                                    <el-tag v-for="a in l.assuntos" :key="a" size="mini" class="u-mr-5">{{ a }}</el-tag>
                                </div>
                            </td>
                            <td>{{ l.ementa }}</td>
                            <td>{{ dataBr(l.data_publicacao) }}</td>
                            <td class="u-text-center">
                                <el-tag :type="l.vigente ? 'success' : 'info'" size="mini">{{ l.vigente ? 'Vigente' : 'Revogada' }}</el-tag>
                            </td>
                            <td class="u-text-center acao">
                                <!--
                                    Espaçamento uniforme: cada ação leva `u-ml-10`, e a folga
                                    fica sempre à ESQUERDA. Antes o editar usava `u-mr-10` —
                                    margem à direita —, então entre o link e o editar não
                                    sobrava nada, e o intervalo mudava conforme a norma tivesse
                                    ou não PDF e URL.
                                -->
                                <el-button v-if="l.arquivo_path" @click="abrirArquivo(l)" title="Abrir PDF" icon="el-icon-document" size="mini" plain></el-button>
                                <el-button class="u-ml-10" v-if="l.url" @click="abrirUrl(l)" title="Abrir link oficial" icon="el-icon-link" size="mini" plain></el-button>
                                <router-link v-if="podeEscrever" :to="'/admin/legislacao/edit/' + l.id" class="link-icon u-ml-10" style="color: rgba(0,0,0,.87) !important;">
                                    <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                                </router-link>
                                <el-button class="u-ml-10" v-if="podeEscrever" @click="excluir(l.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                            </td>
                        </tr>
                        <tr v-if="items.length === 0"><td colspan="5" class="u-text-center">Nenhuma norma encontrada.</td></tr>
                    </tbody>
                </table>
                <div v-if="!statusList" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>
            </div>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO G — item 35. Interface para `api/legislacao`. */
export default {
    data: () => ({
        statusList: false, filtro: { busca: '', tipo: '', esfera: '', vigente: '' }, items: [],
        tipos: ['lei', 'decreto', 'portaria', 'resolucao', 'parecer', 'convencao', 'instrucao_normativa'],
        esferas: ['federal', 'estadual', 'municipal', 'internacional']
    }),
    computed: {
        podeEscrever () { return [4, 5, 6, 7].includes(parseInt(this.$store.state.user.tipo)) }
    },
    mounted () { this.carregar() },
    methods: {
        carregar () {
            this.statusList = false
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/legislacao/getAllPaginate?page=1`,
                this.filtro, this.$store.getters.getHeaderAuth
            ).then(r => { this.items = r.data.data || []; this.statusList = true })
             .catch(e => this.$store.commit('throwException', e))
        },
        rotulo (v) {
            return { lei: 'Lei', decreto: 'Decreto', portaria: 'Portaria', resolucao: 'Resolução',
                parecer: 'Parecer', convencao: 'Convenção', instrucao_normativa: 'Instrução Normativa',
                federal: 'Federal', estadual: 'Estadual', municipal: 'Municipal',
                internacional: 'Internacional' }[v] || v
        },
        dataBr (d) {
            if (!d) return '—'
            const p = d.substring(0, 10).split('-')
            return `${p[2]}/${p[1]}/${p[0]}`
        },
        abrirArquivo (l) { window.open(`${this.$store.state.config.baseUrlApi}/storage/${l.arquivo_path}`, '_blank') },
        abrirUrl (l) { window.open(l.url, '_blank') },
        excluir (id) {
            this.$confirm('Excluir esta norma? Para apenas marcá-la como revogada, edite-a e desmarque a vigência.',
                'Confirmação', { confirmButtonText: 'Excluir', cancelButtonText: 'Cancelar', type: 'warning' }
            ).then(() => {
                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/legislacao/delete/${id}`,
                    this.$store.getters.getHeaderAuth
                ).then(r => {
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: 'Norma excluída.', type: 'success' })
                    this.carregar()
                }).catch(e => this.$store.commit('throwException', e))
            }).catch(() => {})
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
